import React from 'react';
import Hero from './components/administration/wardens/Hero';
import Main from './components/administration/wardens/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Wardens = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default Wardens;